import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/tesla/icon-warning.png'


const _withScopeId = n => (_pushScopeId("data-v-7056f850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "form-wrapper" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item-prefix" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "form-item-tips"
}
const _hoisted_8 = { class: "form-item-error" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-item-suffix" }
const _hoisted_12 = { class: "form-item-error" }
const _hoisted_13 = {
  key: 0,
  class: "form-item"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-item-error" }
const _hoisted_16 = {
  key: 1,
  class: "form-item"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "form-item-error" }
const _hoisted_19 = {
  key: 2,
  class: "form-item"
}
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "form-item-error" }
const _hoisted_22 = {
  key: 0,
  class: "form-item"
}
const _hoisted_23 = { class: "form-item-content" }
const _hoisted_24 = ["onUpdate:modelValue", "onInput", "placeholder"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-item-error" }, null, -1))
const _hoisted_26 = { class: "form-proto" }
const _hoisted_27 = { class: "form-proto-content" }
const _hoisted_28 = {
  key: 3,
  class: "form-error"
}
const _hoisted_29 = {
  key: 1,
  class: "form-result"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "form-result-title" }
const _hoisted_32 = { class: "form-result-desc" }
const _hoisted_33 = { class: "form-result form-result-modal" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "form-result-icon"
}, null, -1))
const _hoisted_35 = { class: "form-result-title" }
const _hoisted_36 = { class: "form-result-desc" }

import { ref, reactive, computed, onBeforeMount } from 'vue';
import { TCheckbox, TModal } from '@tencent/web-vbui';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { CommonSelect } from './components';
import { baseMixins } from '@common/mixins/baseMixins';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { getServerTime, to } from '@tencent/vb-web-base-core';
import { getConfigCommon } from '@common/core/network/activityAPI';
import { ICommonPreRegisterConfig } from '../../core/interface/IModel';
import Contract from '@tencent/vb-web-contract';
import { SendAuthCode, RegisterNameList } from '../../core/network/NodeAPI';
import { encryptText } from '../../core/utils';
import { getUrlQuery } from '@common/utils/param';

export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

const actId = getUrlQuery('id') || 'loanCommonPreRegister';

const { getT } = i18n;
const lang = i18n.getLang();
const $t = getT();
const { isEng, showLoading, showModalError } = baseMixins();
const state = reactive({
  status: 'init',
  showModal: false,
  btnStatus: 'normal'
});
const result = reactive({
  icon: '',
  title: '',
  desc: '',
  btn: '',
  error: ''
});

const formData = reactive({
  areaCode: '+852',
  mobile: '',
  code: '',
  email: '',
  name: '',
  hkid: '',
  other1: '',
  other2: '',
  other3: '',
  isAgree: false
});

const error = reactive({
  mobile: '',
  code: '',
  email: '',
  name: '',
  hkid: '',
  other1: '',
  other2: '',
  other3: '',
});

const configInfo = reactive({
  activityName: '',
  groupId: '',
  contractKey: '',
  activityNoList: [] as string[],
  emailSet: '',
  nameSet: '',
  HKIDSet: '',
  otherFormItemList: [] as { configSet: string; configText: string; configKey: 'other1' | 'other2' | 'other3'; }[],
});

const areaCodeList = [
  {
    value: '+852',
    label: '+852'
  },
  {
    value: '+86',
    label: '+86'
  }
];

const inputVerify = (type: string, e: Event) => {
  if (result.error) {
    result.error = '';
  }
  const { value } = e.target as HTMLInputElement;
  switch (type) {
    case 'mobile':
      error.mobile = '';
      if (value.length > 0 && !/^[0-9]+$/.test(value)) {
        error.mobile = $t('手机号码格式不正确');
      }
      break;
    case 'code':
      error.code = '';
      if (value.length > 0 && !/^[0-9]+$/.test(value)) {
        error.code = $t('验证码格式不正确');
      }
      break;
    case 'email':
      error.email = '';
      if (value.length > 0 && !/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(value)) {
        error.email = $t('邮箱格式不正确');
      }
      break;
    case 'name':
      error.name = '';
      if (value.length > 0 && !/^[a-zA-Z0-9\u4E00-\u9FA5]+$/.test(value)) {
        error.name = $t('姓名格式不正确');
      }
      break;
    case 'hkid':
      error.hkid = '';
      if (value.length > 0 && !/^[a-zA-Z0-9]+$/.test(value)) {
        error.hkid = $t('HKID格式不正确');
      }
      break;
    // case 'other1':
    // case 'other2':
    // case 'other3':
    //   error[type] = '';
    //   if (value.length > 0 && !/^[a-zA-Z0-9]+$/.test(value)) {
    //     error[type] = $t('格式不正确');
    //   }
    //   break;
    default:
      break;
  }
};

const codeBtnText = ref($t('获取验证码'));
const isCodeBtnEnable = ref(true);

const getCaptchaCode = async () => {
  if (!isCodeBtnEnable.value) {
    return;
  }

  reportStatistics({ evtName: 'register-getCaptchaCode' });

  if (!formData.mobile || !/^[0-9]+$/.test(formData.mobile)) {
    toast.show({
      title: $t('手机号码格式不正确'),
      timeout: 1000,
    });
    return;
  }

  reportStatistics({ evtName: 'register-getCaptchaCode-request' });

  // 获取验证码请求
  const [, error] = await to(SendAuthCode({
    areaCode: formData.areaCode,
    mobile: encryptText(formData.mobile)
  }));
  if (error) {
    toast.show({
      title: $t('获取验证码失败'),
      timeout: 2000,
    });
    return;
  }

  let second = 60;

  codeBtnText.value = `${$t('重新获取')}(${second}${$t('秒')})`;
  isCodeBtnEnable.value = false;

  const tick = setInterval(() => {
    second -= 1;
    if (second === 0) {
      clearInterval(tick);

      codeBtnText.value = $t('重新获取');
      isCodeBtnEnable.value = true;
    } else {
      codeBtnText.value = `${$t('重新获取')}(${second}${$t('秒')})`;
    }
  }, 1000);
};

const getConfigData = async () => {
  const [data, err] = await to(getConfigCommon<ICommonPreRegisterConfig>(actId));
  if (err) {
    showModalError(err.message, err.code);
  }
  const {extInfo, activityNoList, startTime, endTime} = data;

  // getServerTime 的返回需要乘以 1000 才能与接口的时间戳对齐
  const now = getServerTime() * 1000;

  const isTimeNotStart = now < startTime;
  if (isTimeNotStart) {
    state.status = '';
    result.title = $t('活动尚未开始，敬请期待！');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    result.icon = require('../../assets/images/tesla/icon-date.png');
  }
  const isTimeEnd = endTime < now;
  if (isTimeEnd) {
    state.status = '';
    result.title = $t('活动已经结束，感谢支持！');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    result.icon = require('../../assets/images/tesla/icon-out.png');
  }
  configInfo.activityName = extInfo[`activityName-${lang}`]?.value || '';
  configInfo.groupId = extInfo.groupId.value;
  configInfo.activityNoList = activityNoList;
  configInfo.contractKey = extInfo.contractKey.value;
  configInfo.emailSet = extInfo.emailSet.value;
  configInfo.nameSet = extInfo.nameSet.value;
  configInfo.HKIDSet = extInfo.HKIDSet.value;
  [1, 2, 3].forEach(item => {
    const configKey = `other${item}` as 'other1' | 'other2' | 'other3';
    const configText = extInfo[`other${item}-${lang}`]?.value || '';
    const configSet = extInfo[`other${item}Set`]?.value || '';
    if (configSet) {
      configInfo.otherFormItemList.push({
        configKey,
        configSet,
        configText,
      });
    }
  });
  console.log(configInfo, 12345);
};

const isBtnDisabled = computed(
  () => !formData.isAgree || !formData.mobile.trim() || !formData.code.trim()
    || (configInfo.emailSet === 'M' && !formData.email.trim())
    || (configInfo.nameSet === 'M' && !formData.name.trim())
    || (configInfo.HKIDSet === 'M' && !formData.hkid.trim())
    || (configInfo.otherFormItemList[0]?.configSet === 'M' && !formData.other1.trim())
    || (configInfo.otherFormItemList[1]?.configSet === 'M' && !formData.other2.trim())
    || (configInfo.otherFormItemList[2]?.configSet === 'M' && !formData.other3.trim())
    || error.mobile || error.code || error.email || error.name || error.hkid || error.other1 || error.other2 || error.other3
    || state.btnStatus === 'disabled'
);

const submit = async () => {
  if (isBtnDisabled.value) {
    return;
  }
  showLoading(true);
  await reportStatistics({ evtName: 'register-submit' });
  const params = {
    areaCode: formData.areaCode,
    mobile: encryptText(formData.mobile),
    code: formData.code,
    groupNo: configInfo.groupId,
    contractKey: configInfo.contractKey,
    actId,
    activityNos: configInfo.activityNoList,
    email: (formData.email && encryptText(formData.email)) || undefined,
    name: formData.name || undefined,
    hkid: (formData.hkid && encryptText(formData.hkid)) || undefined,
    other1: formData.other1 || undefined,
    other2: formData.other2 || undefined,
    other3: formData.other3 || undefined,
  };
  const [, err] = await to(RegisterNameList(params));
  if (err) {
    showLoading(false);
    genErrText(err.code, err.message);
    return;
  }
  showLoading(false);
  state.status = 'suc';
  result.title = $t('恭喜，您已成功登记{name}活动资格', {name: configInfo.activityName});
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  result.icon = require('../../assets/images/tesla/icon-suc.png');
  result.btn = $t('打开/下载 Fusion Bank App');
};

// 查看协议
const checkProto = async (key: string) => {
  const contract = new Contract({
    key,
    autoSign: false,
    containerType: 'normal',
    needAgree: false,
    needCheckBox: false,
    hideBtn: true,
    needTitle: false,
    needLogin: false,
    viewType: 'location'
  });
  await contract.preview();
};

const genErrText = (code: number, message: string) => {
  // if ([1611059247].includes(code)) {
  //   result.title = $t('登记规则不通过');
  // }
  if ([1611059248].includes(code)) {
    state.status = '';
    result.title = $t('您已登记{name}，无需重复登记', {name: configInfo.activityName});
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    result.icon = require('../../assets/images/tesla/icon-warning.png');
  } else {
    result.error = message;
  }
};

const confirm = ()=> {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  window.top!.location.href = 'https://www.fusionbank.com/download.html';
};

onBeforeMount(() => {
  getConfigData();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.status === 'init')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref($t)('立即登记手机号及您的信息预留活动资格')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-item-content", {'form-item-content_error': error.mobile}])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(CommonSelect), {
                    modelValue: formData.areaCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.areaCode) = $event)),
                    selectList: areaCodeList
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  maxlength: "11",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.mobile) = $event)),
                  type: "text",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (inputVerify('mobile', $event))),
                  placeholder: _unref($t)('输入手机号'),
                  class: "form-item-input"
                }, null, 40, _hoisted_6), [
                  [_vModelText, formData.mobile]
                ])
              ], 2),
              (!error.mobile)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref($t)('登记后不能更改')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_8, _toDisplayString(error.mobile), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-item-content", {'form-item-content_error': error.code}])
              }, [
                _withDirectives(_createElementVNode("input", {
                  maxlength: "6",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.code) = $event)),
                  type: "text",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (inputVerify('code', $event))),
                  placeholder: _unref($t)('输入验证码'),
                  class: "form-item-input"
                }, null, 40, _hoisted_10), [
                  [_vModelText, formData.code]
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", { onClick: getCaptchaCode }, _toDisplayString(codeBtnText.value), 1)
                ])
              ], 2),
              _createElementVNode("p", _hoisted_12, _toDisplayString(error.code), 1)
            ]),
            (configInfo.emailSet && configInfo.emailSet !== 'N')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-item-content", {'form-item-content_error': error.email}])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      maxlength: "50",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.email) = $event)),
                      type: "text",
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (inputVerify('email', $event))),
                      placeholder: _unref($t)('输入邮箱'),
                      class: "form-item-input"
                    }, null, 40, _hoisted_14), [
                      [_vModelText, formData.email]
                    ])
                  ], 2),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(error.email), 1)
                ]))
              : _createCommentVNode("", true),
            (configInfo.nameSet && configInfo.nameSet !== 'N')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-item-content", {'form-item-content_error': error.name}])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      maxlength: "20",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.name) = $event)),
                      type: "text",
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (inputVerify('name', $event))),
                      placeholder: _unref($t)('输入姓名'),
                      class: "form-item-input"
                    }, null, 40, _hoisted_17), [
                      [_vModelText, formData.name]
                    ])
                  ], 2),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(error.name), 1)
                ]))
              : _createCommentVNode("", true),
            (configInfo.HKIDSet && configInfo.HKIDSet !== 'N')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-item-content", {'form-item-content_error': error.hkid}])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      maxlength: "20",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.hkid) = $event)),
                      type: "text",
                      onInput: _cache[10] || (_cache[10] = ($event: any) => (inputVerify('hkid', $event))),
                      placeholder: _unref($t)('输入HKID'),
                      class: "form-item-input"
                    }, null, 40, _hoisted_20), [
                      [_vModelText, formData.hkid]
                    ])
                  ], 2),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(error.hkid), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configInfo.otherFormItemList, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                (item.configSet !== 'N')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          maxlength: "50",
                          "onUpdate:modelValue": ($event: any) => ((formData[item.configKey]) = $event),
                          type: "text",
                          onInput: ($event: any) => (inputVerify(item.configKey, $event)),
                          placeholder: item.configText,
                          class: "form-item-input"
                        }, null, 40, _hoisted_24), [
                          [_vModelText, formData[item.configKey]]
                        ])
                      ]),
                      _hoisted_25
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(TCheckbox), {
                modelValue: formData.isAgree,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.isAgree) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)('本人常居于香港及持有香港居民身份证，并年满十八岁。本人已阅读及同意富融银行')), 1),
                _createElementVNode("a", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (checkProto('loanPersonal')))
                }, _toDisplayString(_unref($t)('隐私政策通知书')), 1),
                _createElementVNode("span", null, _toDisplayString(_unref($t)('及')), 1),
                _createElementVNode("a", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (checkProto(configInfo.contractKey)))
                }, _toDisplayString(_unref($t)('本活动的条款及细则')), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(isEng) ? 'of this event' : ''), 1)
              ])
            ]),
            (result.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(result.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: submit,
              class: _normalizeClass(["form-btn", {'form-btn_disabled': _unref(isBtnDisabled)}])
            }, _toDisplayString(_unref($t)('立即登记')), 3)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("img", {
            src: result.icon,
            alt: "",
            class: "form-result-icon"
          }, null, 8, _hoisted_30),
          _createElementVNode("p", _hoisted_31, _toDisplayString(result.title), 1),
          _createElementVNode("p", _hoisted_32, _toDisplayString(result.desc), 1),
          (result.btn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "form-result-btn",
                onClick: confirm
              }, _toDisplayString(result.btn), 1))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_unref(TModal), {
      modelValue: state.showModal,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.showModal) = $event)),
      "cancel-text": _unref($t)('我知道了1')
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("p", _hoisted_35, _toDisplayString(result.title), 1),
          _createElementVNode("p", _hoisted_36, _toDisplayString(result.desc), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "cancel-text"])
  ]))
}
}

})